import { render, staticRenderFns } from "./preferential.vue?vue&type=template&id=7d087f23&scoped=true&"
import script from "./preferential.vue?vue&type=script&lang=js&"
export * from "./preferential.vue?vue&type=script&lang=js&"
import style0 from "./preferential.vue?vue&type=style&index=0&id=7d087f23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d087f23",
  null
  
)

export default component.exports